import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import StudioLayout from "@/components/layouts/StudioLayout";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";

export default function StudioSubscribers() {
  const [tenant, setTenant] = useState(null);
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/tenant/me"), api.get("/tenant/subscribers")])
      .then(([t, s]) => { setTenant(t.data); setSubs(s.data); })
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail) || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <StudioLayout tenant={tenant}>
      <div className="mb-8">
        <p className="text-[11px] uppercase tracking-[0.4em] text-white/40">Studio admin · Subscribers</p>
        <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl tracking-tight">Your audience</h1>
      </div>
      <div className="border border-white/10 bg-[#121212]">
        <Table>
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-[10px] uppercase tracking-[0.25em] text-white/40">Email</TableHead>
              <TableHead className="text-[10px] uppercase tracking-[0.25em] text-white/40">Name</TableHead>
              <TableHead className="text-[10px] uppercase tracking-[0.25em] text-white/40">Joined</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-testid="studio-subscribers-table">
            {loading ? (
              <TableRow><TableCell colSpan={3} className="text-center text-white/40 py-12 text-xs uppercase tracking-widest">Loading…</TableCell></TableRow>
            ) : subs.length === 0 ? (
              <TableRow><TableCell colSpan={3} className="text-center text-white/40 py-12 text-xs uppercase tracking-widest">No subscribers yet</TableCell></TableRow>
            ) : (
              subs.map((s) => (
                <TableRow key={s.id} className="border-white/10 hover:bg-white/5">
                  <TableCell className="text-sm">{s.email}</TableCell>
                  <TableCell className="text-sm text-white/70">{s.full_name}</TableCell>
                  <TableCell className="text-xs text-white/50">{(s.created_at || "").slice(0, 10)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </StudioLayout>
  );
}
